import * as React from "react";
const SvgFiRrHatBirthday = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hat-birthday_svg__a)">
      <path
        fill="#062147"
        d="M22.139 17.778 13.592 5.534a3 3 0 1 0-3.184 0L1.86 17.778A4.12 4.12 0 0 0 1.4 22.02 3.99 3.99 0 0 0 5.127 24h13.746a3.99 3.99 0 0 0 3.727-1.98 4.12 4.12 0 0 0-.461-4.242M11.73 22l5.458-7.819 1.41 2.027L14.562 22zm-5.192 0 8.054-11.538 1.376 1.972L9.292 22zm-3.37-.906a2.15 2.15 0 0 1 .33-2.172L12 6.747l1.382 1.978c-.014.018-.034.027-.047.045L4.2 21.86a1.64 1.64 0 0 1-1.03-.766m17.66 0a2.05 2.05 0 0 1-1.956.906H17l2.822-4.044.675.966c.5.608.628 1.442.333 2.172"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hat-birthday_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHatBirthday;
